<template>
  <div class="product">
    <div class="make">
      <div class="make-cen">
        <h1>最优选择 为企业<span style="color: #2B77FF;">量身打造</span></h1>
        <p>高契合度行业方向，快速响应企业需求，多场景深入满足企业数字化全面覆盖</p>
      </div>
    </div>

    <div class="control">
      <div class="control-cen">
        <h1>多业态多场景的高效整合一体化管控系统</h1>
        <p>保持生产的稳定性，让企业真正通过技术和信息革新提升生产力</p>
        <div class="control-list">
            <div @click="show4Content(0)" :class="{ 'active': currentIndex4 === 0 }">
              <img src="../assets/product/control1.png" alt="">
              <p>平台快速搭建</p>
            </div>
            <div @click="show4Content(1)" :class="{ 'active': currentIndex4 === 1 }">
              <img src="../assets/product/control2.png" alt="">
              <p>场景功能全面</p>
            </div>
            <div @click="show4Content(2)" :class="{ 'active': currentIndex4 === 2 }">
              <img src="../assets/product/control3.png" alt="">
              <p>数据安全可靠</p>
            </div>
            <div @click="show4Content(3)" :class="{ 'active': currentIndex4 === 3 }">
              <img src="../assets/product/control4.png" alt="">
              <p>三重平台协作</p>
            </div>
        </div>

        <div class="platform">
          <div class="platform-left">
            <h1>{{ currentIndex4Content[currentIndex4].h1 }}<span style="color: #2B77FF;">{{ currentIndex4Content[currentIndex4].span }}</span></h1>
            <div class="platform-list">
              <p>{{ currentIndex4Content[currentIndex4].p1 }}</p>
              <p style="margin: 34px 0">{{ currentIndex4Content[currentIndex4].p2 }}</p>
              <p>{{ currentIndex4Content[currentIndex4].p3 }}</p>
              <div class="line"></div>
            </div>
            <div class="platform-button">
              <button  @click="openPopUp()">立即体验</button>
              <button @click="openUrl('/productPrice')">了解详情</button>
            </div>
          </div>
          <div class="platform-right">
            <div class="platform-bgurl" id="platform-bgurl">
              <div class="platform-img" v-show="currentIndex4 == 0">
                <img src="../assets/product/4.png" class="fade-in" alt="">
                <img src="../assets/product/3.png" class="fade-in" alt="">
              </div>
              <div class="platform-img" v-show="currentIndex4 == 1">
                <img src="../assets/product/8.png" alt="">
                <img src="../assets/product/9.png" alt="">
              </div>
              <div class="platform-img" v-show="currentIndex4 == 2">
                <img src="../assets/product/11.png" alt="">
                <img src="../assets/product/12.png" alt="">
              </div>
              <div class="platform-img" v-show="currentIndex4 == 3">
                <img alt="" src="空">
                <img alt="" src="空">
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="integration">
      <div class="integration-cen">
        <h1>深入场景的数字化的智能应用集成</h1>
        <p>构建营销获客、销售管理、生产管理、品质检测、设备管理等为一体的数字化闭环</p>
        <div>
          <div class="integration-left">
            <p  @click="showContent(0)" :class="{ 'integration-active': currentIndex === 0 }">产品管理</p>
            <p  @click="showContent(1)" :class="{ 'integration-active': currentIndex === 1 }">销售管理</p>
            <p  @click="showContent(2)" :class="{ 'integration-active': currentIndex === 2 }">供应管理</p>
            <p  @click="showContent(3)" :class="{ 'integration-active': currentIndex === 3 }">仓储管理</p>
            <p  @click="showContent(4)" :class="{ 'integration-active': currentIndex === 4 }">生产管理</p>
            <p  @click="showContent(5)" :class="{ 'integration-active': currentIndex === 5 }">品质管理</p>
            <p  @click="showContent(6)" :class="{ 'integration-active': currentIndex === 6 }">设备管理</p>
            <p  @click="showContent(7)" :class="{ 'integration-active': currentIndex === 7 }">人事管理</p>
            <p  @click="showContent(8)" :class="{ 'integration-active': currentIndex === 8 }">数据分析</p>
          </div>
          <div class="integration-right">
            <div class="integration-img">
              <h3>数字化产品管理</h3>
              <p>{{integrationTitle[currentIndex]}}</p>
            </div>
            <img src="../assets/product/6.png" v-if="currentIndex == 0" alt="">
            <img src="../assets/product/14.png" v-if="currentIndex == 1" alt="">
            <img src="../assets/product/15.png" v-if="currentIndex == 2" alt="">
            <img src="../assets/product/16.png" v-if="currentIndex == 3" alt="">
            <img src="../assets/product/17.png" v-if="currentIndex == 4" alt="">
            <img src="../assets/product/18.png" v-if="currentIndex == 5" alt="">
            <img src="../assets/product/19.png" v-if="currentIndex == 6" alt="">
            <img src="../assets/product/20.png" v-if="currentIndex == 7" alt="">
            <img src="../assets/product/21.png" v-if="currentIndex == 8" alt="">
          </div>
        </div>
      </div>
    </div>

    <pop-up :display="showPopUp" @update:display="updateDisplay"></pop-up>

  </div>
</template>



<script>

// function updateScrollPosition() {
//   const scrollPosition = window.scrollY || window.pageYOffset;

//   if (scrollPosition >= 450) {
//     const images = document.querySelectorAll(".platform-img img");
//     images.forEach((img, index) => {
//       setTimeout(() => {
//         img.classList.add("fade-in");
//       }, index * 500); // 延迟使每张图片逐渐显示
//     });
//   }

// }

// // 添加滚动事件监听器
// window.addEventListener('scroll', updateScrollPosition);

// // 初始调用一次以确保在页面加载时检测位置
// updateScrollPosition();
import popUp from '@/components/popUp.vue'

export default {
  components:{popUp},
  name: 'product',
  data () {
    return {
      currentIndex: 0,
      currentIndex4: 0,
      currentIndex4Content: [
        {
          h1: '助力企业搭建',
          span: '数智管理平台',
          p1: '快速模块搭建',
          p2: '功能灵活自选',
          p3: '丰富数据呈现',
        },
        {
          h1: '深度覆盖企业',
          span: '所有生产场景',
          p1: '工作场景涵盖全面',
          p2: '功能模块搭配灵活',
          p3: '实现销售生产闭环',
        },
        {
          h1: '全方位保护',
          span: '企业各项数据',
          p1: '完备的安全策略',
          p2: '精细的权限管理',
          p3: '权威的安全认证',
        },
        {
          h1: '随时随地',
          span: '完成所有工作使命',
          p1: '多平台满足不同办公场景',
          p2: '集成所有系统和数据',
          p3: '数据互通方便快捷',
        },
      ],
      showPopUp: false,
      integrationTitle: [
          "产品管理涉及从产品构思、开发到上市的整个过程。它包括市场研究、需求分析、产品设计、开发、测试、发布和生命周期管理。产品经理需要协调跨部门团队，确保产品满足市场需求并在竞争中保持优势。",
          "销售管理是指制定和实施销售战略以实现公司的销售目标。它包括销售计划制定、销售团队管理、客户关系管理和销售绩效评估。有效的销售管理能够提高销售效率、增加客户满意度和推动公司业绩增长。",
          "供应管理（或供应链管理）涉及采购、物流和库存管理。其目的是确保所需材料和产品在正确的时间、地点和成本下可用。通过优化供应链流程，可以降低成本、提高效率和增强企业竞争力。",
          "仓储管理包括库存管理、货物储存和配送。它旨在确保库存的准确性、减少库存成本和提高货物流动速度。有效的仓储管理能够保证产品的及时交付和客户满意度。",
          "生产管理涉及规划、组织、指导和控制生产过程。其目的是确保产品按照预定的时间、成本和质量标准生产。生产管理包括生产计划、工艺设计、设备维护和质量控制。",
          "品质管理是确保产品或服务满足客户需求和期望的一系列活动。它包括质量规划、质量控制、质量保证和质量改进。通过持续改进质量管理体系，可以提高产品质量、降低成本和提升客户满意度。",
          "设备管理涉及设备的采购、维护和更新。其目的是确保设备正常运行、延长设备使用寿命和降低维护成本。有效的设备管理能够提高生产效率、减少停机时间和保障生产安全。",
          "人事管理（或人力资源管理）包括招聘、培训、绩效管理、薪酬管理和员工关系。其目的是吸引、发展和留住人才，推动员工个人和组织的共同发展。有效的人事管理能够提高员工满意度和组织绩效。",
          "数据分析是通过收集、处理和分析数据来获取有价值的信息和支持决策。它包括数据收集、数据清洗、数据建模和数据可视化。通过数据分析，可以识别趋势、优化业务流程和提高决策的准确性。"
      ]
    }
  },
  created(){
  },
  computed:{
  },
  methods: {
    openPopUp() {
        this.showPopUp = true
    },
    updateDisplay(newValue) {
        this.showPopUp = newValue;
    },
    openUrl(url) {
      
      let urls = this.$router.resolve({
          path: url,
      });
      window.open(urls.href, "_self");
    },
    showContent(index) {
        this.currentIndex = index;
    },
    show4Content(index) {
      this.currentIndex4 = index;
      
      const images = document.querySelectorAll(".platform-img img");
      images.forEach((img, idx) => {
          img.classList.remove("fade-in");
          
          // 使用 setTimeout 确保移除 class 的操作完成后再添加 class
          setTimeout(() => {
              img.classList.add("fade-in");
          }, idx * 200); // 延迟使每张图片逐渐显示
          
          // 先移除 fade-in 类
      });

      const bgImages = [
        require(`../assets/product/2.png`),
        require(`../assets/product/7.png`),
        require(`../assets/product/10.png`),
        require(`../assets/product/13.png`),
      ];

      const bgurl = document.getElementById('platform-bgurl')
      bgurl.style.backgroundImage = `url(${bgImages[index]})`;

    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.make {
  background: url(../assets/product/1.png);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  height: 522px
}
.make-cen,.control-cen,.integration-cen {
  width: 1460px;
  margin: 0 auto;
}
.make-cen {
  padding-top: 148px;
}
.make-cen h1 {
  font-weight: bold;
  font-size: 70px;
  color: #3F3F3F;
  font-style: normal;
  margin-bottom: 16px;
}
.make-cen p {
  font-weight: 400;
  font-size: 18px;
  color: #3F3F3F;
}

.control,.integration {
  background: #fff;
}
.control-cen {
  padding-top: 82px;
  padding-bottom: 80px;
}
.control-cen > h1 {
  text-align: center;
  font-weight: bold;
  font-size: 36px;
  color: #3F3F3F;
  margin-bottom: 10px;
}
.control-cen > p {
  font-weight: 400;
  font-size: 14px;
  color: #3F3F3F;
  text-align: center;
}
.control-list {
  display: flex;
  justify-content: space-between;
  width: 1166px;
  margin: 0 auto;
  padding: 64px 0
}
.control-list > div {
  width: 206px;
  height: 60px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  cursor: pointer;
  transition: all .2s;
}
.control-list > .active {
  background: #2B77FF;
  color: #fff
}
.control-list > div:hover {
  background: #2B77FF;
  color: #fff
}

.platform {
  width: 1460px;
  height: 500px;
  background: #F7F9FF;
  padding-top: 56px;
  padding-left: 148px;
  padding-right: 138px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}
.platform-left h1 {
  font-weight: 500;
  font-size: 32px;
  color: #3F3F3F;
  margin-bottom: 56px;
}

.platform-list {
  /* border-left: 1px solid #2B77FF; */
  margin-bottom: 50px;
  position: relative;
}
.platform-list p {
  padding-left: 18px;
  position: relative;
}
.platform-list p::before {
  content: '';
  width: 16px;
  height: 16px;
  background: #2B77FF;
  position: absolute;
  left: -9px;
  top: 3px;
  border-radius: 50%;
}
.line {
  width: 1px;
  height: 110px;
  background: #2B77FF;
  position: absolute;
  left: -1px;
  top: 6px;
}
.platform-button button {
    width: 182px;
    height: 40px;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s;
}
.platform-button button:nth-child(1) {
    background: #2B77FF;
    margin-right: 16px;
}
.platform-button button:nth-child(2) {
    color: #2B77FF;
    border: 1px solid #2B77FF;
    box-sizing: border-box;
    background: #eef4fc;
}
.platform-button button:nth-child(1):hover {
    background-color: #1a5bcc; /* 添加按钮悬停效果 */
}
.platform-button button:nth-child(2):hover {
    background-color: #377ee7; /* 添加按钮悬停效果 */
    color: #fff;
}
.platform-right {

}
.platform-bgurl {
  background: url(../assets/product/2.png);
  width: 620px;
  height: 320px;
  position: relative;
}
.platform-img {
  position: absolute;
  top: 76px;
  right: -106px;
}
.platform-img img {
  display: block;
  opacity: 0;
  transition: opacity .8s ease-in-out;
}
.platform-img img.fade-in {
  opacity: 1;
}

.integration {

}
.integration-cen {
  padding-top: 72px;
  padding-bottom: 80px;
  text-align: center;
}
.integration-cen > h1 {
  font-weight: bold;
  font-size: 36px;
  color: #3F3F3F;
  margin-bottom: 10px;
}
.integration-cen > p {
  font-weight: 400;
  font-size: 14px;
  color: #3F3F3F;
  margin-bottom: 68px;
}
.integration-cen > div {
  display: flex;
}
.integration-left {
  width: 260px;
  background: #F7F9FF;
  border-radius: 8px;
  padding: 42px 0;
  box-sizing: border-box;
  margin-right: 20px;
}
.integration-left p{
  font-weight: 400;
  font-size: 24px;
  color: #3F3F3F;
  line-height: 87px;
  position: relative;
  cursor: pointer;
}
.integration-left .integration-active {
  color: #3C75FF;
  background: linear-gradient( 90deg, #FFFFFF 0%, rgba(255,255,255,0.65) 100%);
}
.integration-left .integration-active::after {
  content: '';
  width: 8px;
  height: 87px;
  background: #3068FF;
  position: absolute;
  left: 0
}
.integration-img {
  width: 1160px;
  height: 135px;
  background: url(../assets/product/5.png);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  margin-bottom: 20px;
  padding-top: 22px;
  padding-left: 42px;
  box-sizing: border-box;
  text-align: left;
}
.integration-img h3 {
  font-weight: 500;
  font-size: 24px;
  color: #3F3F3F;
  margin-bottom: 6px;
}
.integration-img p {
  font-weight: 400;
  font-size: 20px;
  color: #3F3F3F;
}
.integration-right img {
  width: 1160px;
  height: 718px;
}

</style>



// WEBPACK FOOTER //
// src/components/product.vue